import { Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from '../../utils/PrivateRoute';
import { TableLandingBorrowPage } from "../../pages/borrowSystem/TableLandingBorrowPage";
import { FormBorrowPage } from '../../pages/borrowSystem/BorrowForm/FormBorrowPage';
import { FormTrainPage } from '../../pages/borrowSystem/BorrowForm/FormTrainPage';
import { FormTestPage } from '../../pages/borrowSystem/BorrowForm/FormTestPage';
import { JobPositionFormTestPage } from '../../pages/borrowSystem/BorrowForm/JobPositionFormTestPage';
import { JobPositionFormTrainPage } from '../../pages/borrowSystem/BorrowForm/JobPositionFormTrainPage';
//add page attatch file 
import { AttatchFileTestPage } from '../../pages/borrowSystem/BorrowForm/AttatchFileTestPage';
import { AttatchFileTrainPage } from '../../pages/borrowSystem/BorrowForm/AttatchFileTrainPage';
import { CheckBorrowSixPage } from '../../pages/borrowSystem/CheckBorrowSixPage';
import { ChangeBorrowCourseFormPage } from '../../pages/borrowSystem/ChangeAndExtendBorrowForm/ChangeBorrowCourseFormPage';
import { ExtendBorrowFormPage } from '../../pages/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowFormPage'
import { ChangeBorrowCheckPage } from '../../pages/borrowSystem/ChangeAndExtendBorrowForm/ChangeBorrowCheckPage'
import { ExtendBorrowCheckPage } from '../../pages/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowCheckPage'
import { ExtendBorrowDetailPage } from '../../pages/borrowSystem/ChangeAndExtendBorrowForm/ExtendBorrowDetailPage'
import { AdminApproveBorrowFormPage } from '../../pages/borrowSystem/AdminApproveBorrowFormPage';
import { BorrowFollowSixPage } from "../../pages/borrowSystem/BorrowFollowSixPage";
import { BorrowFollowEightPage } from "../../pages/borrowSystem/BorrowFollowEightPage";
import { AdminCheckPage } from "../../pages/borrowSystem/AdminCheckPage";
import { ListReportPage } from '../../pages/borrowSystem/Report/ListReportPage';
import { ConCludeBorrowPage } from '../../pages/borrowSystem/Report/ConCludeBorrowPage';
import { Report192Page } from '../../pages/borrowSystem/Report/Report192Page';
import { Report193Page } from '../../pages/borrowSystem/Report/Report193Page';
import { Report194Page } from '../../pages/borrowSystem/Report/Report194Page';
import { Report195Page } from '../../pages/borrowSystem/Report/Report195Page';
import { Report196Page } from '../../pages/borrowSystem/Report/Report196Page';
import { Report197Page } from '../../pages/borrowSystem/Report/Report197Page';
import { Report198Page } from '../../pages/borrowSystem/Report/Report198Page';
import { Report199Page } from '../../pages/borrowSystem/Report/Report199Page';
import { Report1910Page } from '../../pages/borrowSystem/Report/Report1910Page';
import { Report1911Page } from '../../pages/borrowSystem/Report/Report1911Page';
import { Report1912Page } from '../../pages/borrowSystem/Report/Report1912Page';
import { Report1913Page } from '../../pages/borrowSystem/Report/Report1913Page';
import { Report1914Page } from '../../pages/borrowSystem/Report/Report1914Page';
import { Report1915Page } from '../../pages/borrowSystem/Report/Report1915Page';
import { Report1916Page } from '../../pages/borrowSystem/Report/Report1916Page';
import { Report1917Page } from '../../pages/borrowSystem/Report/Report1917Page';
import { Report1918Page } from '../../pages/borrowSystem/Report/Report1918Page';
import { Report1919Page } from '../../pages/borrowSystem/Report/Report1919Page';
import { Report19201Page } from '../../pages/borrowSystem/Report/Report19201Page';
import { Report19202Page } from '../../pages/borrowSystem/Report/Report19202Page';
import { AdminDetailPage } from "../../pages/borrowSystem/AdminDetailPage";
// แบบเสนอคณะอนุกรรมการ แบบอนุมัติแล้ว  และ แบบเสนอคณะอนุกรรมการ แบบมีการแก้ไข
import { PoposedToTheSubCommittee3ApprovePage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee3ApprovePage';
import { PoposedToTheSubCommittee3EditPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee3EditPage';

import { PoposedToTheSubCommittee4ApprovePage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee4ApprovePage';
import { PoposedToTheSubCommittee4EditPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee4EditPage';

// แบบเสนอคณะอนุกรรมการ
import { LandingPoposedToTheSubCommitteePage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/LandingPoposedToTheSubCommitteePage';
import { PoposedToTheSubCommittee3FormPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee3FormPage';
import { PoposedToTheSubCommittee4FormPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee4FormPage';
import { PoposedToTheSubCommittee3ViewPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee3ViewPage';
import { PoposedToTheSubCommittee4ViewPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/PoposedToTheSubCommittee4ViewPage';
import { DuplicateRecoveryInformationPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/DuplicateRecoveryInformationPage';
import { InformationForBorrowingDetailPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/InformationForBorrowingDetailPage';
import { InformationForBorrowingTestPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/InformationForBorrowingTestPage';
import { InformationForBorrowingTrainPage } from '../../pages/borrowSystem/ProposedToTheSubCommittee/InformationForBorrowingTrainPage';
import { SignBorrowContactPage } from "../../pages/borrowSystem/Contact/SignBorrowContactPage"
//จัดทำหนังสือแจ้งหนี้
import { InvoiceBorrowFormPage } from "../../pages/borrowSystem/Invoice/InvoiceBorrowFormPage"
// แนบไฟล์สำเนาทะเบียนสมรส
import { AttatchFileForContactPage } from '../../pages/borrowSystem/Contact/AttatchFileForContactPage';
//แก้ไขอัตราดอกเบี้ย
import { BorrowAdminChangeInterestPage } from '../../pages/borrowSystem/Contact/BorrowAdminChangeInterestPage';
//รับชำระหนี้คืน
import { ReceivingDebtPage } from '../../pages/borrowSystem/Contact/ReceivingDebtPage';
//บันทึกข้อมูลอนุมัติงบประมาณประจำปี
import { YearbudgetLimitPage } from '../../pages/borrowSystem/Contact/YearbudgetLimitPage';

import { ResultBorrowingPage } from '../../pages/borrowSystem/ResultBorrowingPage';

import { CreateAttatchFileFormTestPage } from '../../pages/Officer/CreateAttatchFileFormTestPage';
import { CreateAttatchFileFormTrainPage } from '../../pages/Officer/CreateAttatchFileFormTrainPage';
import { CreateBorrowFormPage } from '../../pages/Officer/CreateBorrowFormPage';
// import { CreateCompanyRegisterPage } from '../../pages/Officer/CreateCompanyRegisterPage';
import { CreateFormTestPage } from '../../pages/Officer/CreateFormTestPage';
import { CreateFormTrainPage } from '../../pages/Officer/CreateFormTrainPage';
import { CreateJobPositionFormTestPage } from '../../pages/Officer/CreateJobPositionFormTestPage';
import { CreateJobPositionFormTrainPage } from '../../pages/Officer/CreateJobPositionFormTrainPage';
// import { CreatePersonalRegisterPage } from '../../pages/Officer/CreatePersonalRegisterPage';Í

export function AppBorrow() {

    return (

        <Routes>
            <Route element={<PrivateRoute />}>
                {/* สำหรับเจ้าหน้าที่ */}
              
                {/* แบบฟอร์มกู้ยืมเงิน สำหรับเจ้าหน้าที่ */}
                <Route
                    path="/create-borrowing"
                    element={<CreateBorrowFormPage />}
                />
                {/* แบบฟอร์มกู้ยืมเงิน สำหรับฝึกอบรม สำหรับเจ้าหน้าที่*/}
                <Route
                    path="/create-train-borrowing"
                    element={<CreateFormTrainPage />}
                />

                <Route
                    path="/create-train-files"
                    element={<CreateAttatchFileFormTrainPage />}
                />

                <Route
                    path="/create-train-job"
                    element={<CreateJobPositionFormTrainPage />}
                />
                {/* แบบฟอร์มกู้ยืมเงิน สำหรับขอทดสอบ สำหรับเจ้าหน้าที่*/}
                <Route
                    path="/create-testing-borrowing"
                    element={<CreateFormTestPage />}
                />

                <Route
                    path="/create-testing-file"
                    element={<CreateAttatchFileFormTestPage />}
                />

                <Route
                    path="/create-testing-job"
                    element={<CreateJobPositionFormTestPage />}
                />Í




                <Route
                    path="/"
                    element={<TableLandingBorrowPage />}
                />







                <Route
                    path="result-borrowing"
                    element={<ResultBorrowingPage />}
                />

                {/* เอกสารสัญญา */}

                <Route
                    path="contact/attatchFileBorrow"
                    element={<AttatchFileForContactPage />}
                />
                <Route
                    path="contact/changeinterest"
                    element={<BorrowAdminChangeInterestPage />}
                />
                <Route
                    path="contact/receivingDept"
                    element={<ReceivingDebtPage />}
                />
                <Route
                    path="contact/yearbudgetform"
                    element={<YearbudgetLimitPage />}
                />
                <Route
                    path="contact/signContact"
                    element={<SignBorrowContactPage />}
                />


                {/* ---------แบบฟอร์มคำขอกู้ยืมเงิน ดำเนินการฝึกอบรม------------ */}
                <Route
                    path="BorrowForm"
                    element={<FormBorrowPage />}
                />
                <Route
                    path="BorrowForm/trainDetail"
                    element={<FormTrainPage />}
                />

                <Route
                    path="BorrowForm/attatchFileTrain"
                    element={<AttatchFileTrainPage />}
                />

                <Route
                    path="BorrowForm/trainJob"
                    element={<JobPositionFormTrainPage />}
                />

                {/* ---------แบบฟอร์มคำขอกู้ยืมเงิน ดำเนินการทดสอบ------------ */}
                <Route
                    path="BorrowForm/testDetail"
                    element={<FormTestPage />}
                />
                <Route
                    path="BorrowForm/testJob"
                    element={<JobPositionFormTestPage />}
                />
                <Route
                    path="BorrowForm/attatchFileTest"
                    element={<AttatchFileTestPage />}
                />

                {/* ----------------------------------- */}
                <Route
                    path="borrow/borrowFollowSix"
                    element={<BorrowFollowSixPage />}

                />
                <Route
                    path="borrow/checkBorrowFollowSix"
                    element={<CheckBorrowSixPage />}

                />
                {/* หน้าตรวจสอบคำขอกู้ยืมเงินของเจ้าหน้าที่ */}
                <Route
                    path="/admin/check"
                    element={<AdminCheckPage />}
                />
                <Route
                    path="/admin/check/detail"
                    element={<AdminDetailPage />}
                />
                <Route
                    path="/admin/approve/"
                    element={<AdminApproveBorrowFormPage />}
                />


                <Route
                    path="borrow/borrowFollowEight"
                    element={<BorrowFollowEightPage />}
                />


                {/* หน้าจอเปลี่ยนแปลงหลักสูตรการฝึกอบรม/และเปลี่ยนแปลงหลักสูตร */}
                <Route
                    path="/changeBorrowCourseForm"
                    element={<ChangeBorrowCourseFormPage />}
                />
                <Route
                    path="/extendBorrowCourseForm"
                    element={<ExtendBorrowFormPage />}
                />
                <Route
                    path="/ChangeBorrowCheck"
                    element={<ChangeBorrowCheckPage />}
                />
                <Route
                    path="/ExtendBorrowCheck"
                    element={<ExtendBorrowCheckPage />}
                />
                <Route
                    path="/ExtendBorrowDetail"
                    element={<ExtendBorrowDetailPage />}
                />

                {/* หน้าจอแบบเสนอคณะอนุกรรมการ */}
                <Route
                    path="/proposal"
                    element={<LandingPoposedToTheSubCommitteePage />}
                />
                <Route
                    path="/proposal/ProposedToTheSubCommitteeForTrainForm"
                    element={<PoposedToTheSubCommittee3FormPage />}
                />
                <Route
                    path="/proposal/ProposedToTheSubCommitteeForEstimateForm"
                    element={<PoposedToTheSubCommittee4FormPage />}
                />
                <Route
                    path="/proposal/ProposedToTheSubCommitteeForTrainView"
                    element={<PoposedToTheSubCommittee3ViewPage />}
                />
                <Route
                    path="/proposal/ProposedToTheSubCommitteeForEstimateView"
                    element={<PoposedToTheSubCommittee4ViewPage />}
                />

                <Route
                    path="/proposal/ProposedToTheSubCommitteeForTrainApproveView"
                    element={<PoposedToTheSubCommittee3ApprovePage />}
                />
                <Route
                    path="/proposal/ProposedToTheSubCommitteeForTrainEditView"
                    element={<PoposedToTheSubCommittee3EditPage />}
                />
                <Route
                    path="/proposal/ProposedToTheSubCommitteeForEstimateApproveView"
                    element={<PoposedToTheSubCommittee4ApprovePage />}
                />
                <Route
                    path="/proposal/ProposedToTheSubCommitteeForEstimateEditView"
                    element={<PoposedToTheSubCommittee4EditPage />}
                />

                <Route
                    path="/proposal/TrainInfomationForBorrowing"
                    element={<InformationForBorrowingTrainPage />}
                />
                <Route
                    path="/proposal/TestInfomationForBorrowing"
                    element={<InformationForBorrowingTestPage />}
                />
                <Route
                    path="/proposal/DetailInfomationForBorrowing"
                    element={<InformationForBorrowingDetailPage />}
                />
                <Route
                    path="/proposal/DuplicateRecoveryInfomationForBorrowing"
                    element={<DuplicateRecoveryInformationPage />}
                />


                <Route
                    path="/invoice/CreateInvoiceBorrow"
                    element={<InvoiceBorrowFormPage />}
                />

                {/* หน้าจอรายงาน */}
                <Route
                    path="Reports"
                    element={<ListReportPage />}
                >
                </Route>
                <Route
                    path="borrow/Reports/ConcludeBorrow"
                    element={<ConCludeBorrowPage />}
                />
                <Route
                    path="borrow/Reports/19-2"
                    element={<Report192Page />}
                />
                <Route
                    path="borrow/Reports/19-3"
                    element={<Report193Page />}
                />
                <Route
                    path="borrow/Reports/19-4"
                    element={<Report194Page />}
                />
                <Route
                    path="borrow/Reports/19-5"
                    element={<Report195Page />}
                />
                <Route
                    path="borrow/Reports/19-6"
                    element={<Report196Page />}
                />
                <Route
                    path="borrow/Reports/19-7"
                    element={<Report197Page />}
                />
                <Route
                    path="borrow/Reports/19-8"
                    element={<Report198Page />}
                />
                <Route
                    path="borrow/Reports/19-9"
                    element={<Report199Page />}
                />
                <Route
                    path="borrow/Reports/19-10"
                    element={<Report1910Page />}
                />
                <Route
                    path="borrow/Reports/19-11"
                    element={<Report1911Page />}
                />
                <Route
                    path="borrow/Reports/19-12"
                    element={<Report1912Page />}
                />
                <Route
                    path="borrow/Reports/19-13"
                    element={<Report1913Page />}
                />
                <Route
                    path="borrow/Reports/19-14"
                    element={<Report1914Page />}
                />
                <Route
                    path="borrow/Reports/19-15"
                    element={<Report1915Page />}
                />
                <Route
                    path="borrow/Reports/19-16"
                    element={<Report1916Page />}
                />
                <Route
                    path="borrow/Reports/19-17"
                    element={<Report1917Page />}
                />
                <Route
                    path="borrow/Reports/19-18"
                    element={<Report1918Page />}
                />
                <Route
                    path="borrow/Reports/19-19"
                    element={<Report1919Page />}
                />
                <Route
                    path="borrow/Reports/19-201"
                    element={<Report19201Page />}
                />
                <Route
                    path="borrow/Reports/19-202"
                    element={<Report19202Page />}
                />



            </Route>


            <Route path="*" element={<Navigate to="/" replace={true} />} />
        </Routes>

    );

}